// extracted by mini-css-extract-plugin
export default {"header":"styles_header__tq67t","headerContent":"styles_headerContent__Uhc+E"};